// import list from 'page/supervision/list.vue'
// import expert from 'page/supervision/expert.vue'
const list = () =>
  import(/* webpackChunkName: "supervisionlist" */ 'page/supervision/list.vue')
const expert = () =>
  import(
    /* webpackChunkName: "supervisionexpert" */ 'page/supervision/expert.vue'
  )

export default [
  {
    path: '/supervision/list',
    component: list,
    meta: {
      notKeepAlive: true,
      business: '咨询',
      category: '督导',
      pageName: '督导专区'
    }
  },
  {
    path: '/supervision/*.html',
    component: expert,
    meta: {
      business: '咨询',
      category: '督导',
      pageName: '督导师详情页'
    }
  }
]
